import { AddressObject } from 'mailparser';
import { Types } from 'mongoose';

import {
  ADVANCE_MAILBOX_FILTERS,
  BASIC_MAILBOX_FILTERS,
  MAILBOX_FLAG_ACTIONS,
  MAILBOX_FLAGS,
  MAILBOX_TYPES,
} from '@shared/constants';

import { IBaseEntity } from '../common';

export interface IEmailClient extends IBaseEntity {
  isStarred: boolean;
}

export interface IDynamicSignFields {
  key?: string;
  value?: string;
}

export interface IMailboxSignature {
  richText: string;
  fields: IDynamicSignFields[]; // saves key in richtext and formControl name
  allowCustom?: boolean;
}

export interface IMailboxUserSignature {
  richText: string;
  fields: IDynamicSignFields[]; // saves formControl name and formValues
}

export interface ISmtpConfig {
  username?: string;
  password?: string;
  host: string;
  port: number;
  tls: string;
  secure?: boolean;
}

export interface IImapConfig {
  username?: string;
  password?: string;
  host: string;
  port: number;
  tls: string;
  secure?: boolean;
}

export interface IMailboxSetupConfig extends IBaseEntity {
  allowMultipleMailbox: boolean;
  sendTestMessages: boolean;
  smtpConfig: ISmtpConfig;
  imapConfig: IImapConfig;
  signature?: IMailboxSignature;
}

export interface IMailboxUserSettingsConfig extends IBaseEntity {
  displayName: string;
  imapConfig: IImapConfig;
  smtpConfig: ISmtpConfig;
  isCurrent: boolean;
  signature?: IMailboxUserSignature;
  isValidConnection?: boolean;
  created_by?: Types.ObjectId | string;
  isConfigured?: boolean;
}

export interface IAdvanceMailboxFilters {
  key: ADVANCE_MAILBOX_FILTERS;
  value: string | string[];
}

export interface ISearchCriteria {
  basic?: BASIC_MAILBOX_FILTERS | BASIC_MAILBOX_FILTERS[];
  advanced?: IAdvanceMailboxFilters[];
  or?: ISearchCriteria[];
  not?: ISearchCriteria;
}

export interface IMailboxEmailContact {
  name: string;
  email: string;
}

export interface IMailboxFlagEmail {
  uid: number[];
  email?: string;
  boxType: MAILBOX_TYPES;
  messageId?: string;
  action?: MAILBOX_FLAG_ACTIONS;
  flags?: MAILBOX_FLAGS;
  moveToBox?: MAILBOX_TYPES;
}

export interface IEmailAttachment {
  fileName: string;
  data: string;
  file: File;
  download_link?: string;
  filename?: string;
}

export interface IMailboxSendEmailOptions {
  from?: string;
  to?: string[];
  cc?: string[];
  bcc?: string[];
  subject: string;
  text?: string;
  html?: string;
  attachments?: IEmailAttachment[];
  from_name?: string;
  content_type?: string;
  messageId?: string;
}

export interface IMailboxReceiveEmail {
  uid: number;
  messageId?: string;
  flags: string[]; // this contains the UNSEEN / SEEN / STARRED / RECENT tags
  isStarred?: boolean;
  isSeen?: boolean;
  from: AddressObject | undefined;
  to: AddressObject | AddressObject[] | undefined | string[];
  cc?: AddressObject | AddressObject[] | undefined | string[];
  bcc?: AddressObject | AddressObject[] | undefined | string[];
  replyTo: AddressObject;
  subject?: string;
  date: Date | string;
  body?: string;
  bodyAsText: string;
  attachments: any[];
  email_id?: string;
  to_folder?: string;
  from_folder?: string;
}

export interface IMailboxEmailResponse {
  totalEmails: number;
  unreadEmails: number;
  mailbox: MAILBOX_TYPES;
  emails: IMailboxReceiveEmail[];
}

export interface IPushNotificationEmail {
  messageId?: string;
  from?: string;
  to?: string;
  subject?: string;
  date?: string;
  body?: string;
}

export enum SIDEBAR_ITEM_TYPE {
  COMPOSE = 'COMPOSE',
  INBOX = 'INBOX',
  SEND = 'SEND',
  DRAFT = 'DRAFT',
  SPAM = 'SPAM',
  EDIT = 'EDIT',
  MAIL = 'MAIL',
  ARCHIVE = 'ARCHIVE',
  TRASH = 'TRASH',
  SETTINGS = 'SETTINGS',
  PROFILE = 'PROFILE',
  STARRED = 'STARRED',
}

export interface ISideBarItems {
  btnType: SIDEBAR_ITEM_TYPE;
  label: string;
  icon?: string;
  is_active: boolean;
  count?: number;
}

export interface IUserListItem {
  name: string;
  email: string;
  is_active?: boolean;
}
